import { t } from './index';
import { translate } from './catalog';

const normalize = value => String(value ?? '').toLowerCase().normalize('NFKC')
  .replace(/[\u064B-\u065F\u0670\u0640]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').trim();

export function matchesOption(option, query, language) {
  const label = option?.label ?? option?.name ?? option;
  return normalize(`${label} ${language ? translate(label, language) : t(label)} ${option?.name_ar || option?.raw?.name_ar || ''}`).includes(normalize(query));
}

// Display labels can change language while the selected ID/canonical value stays put.
export function displayOptionInput(value, options) {
  return options.some(option => option.label === value) ? t(value) : value;
}
